// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PlaceholderProductSearch_RequirementsTliQueryVariables = Types.Exact<{
  placeholderTliId: Types.Scalars['ID']['input'];
}>;


export type PlaceholderProductSearch_RequirementsTliQuery = { __typename?: 'Query', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }>, materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }> } } };

export type PlaceholderProductSearch_RequirementsMaterialFragment = { __typename?: 'MaterialVariant', id: string, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }> };

export type PlaceholderProductSearch_RequirementsItemFragment = { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }>, materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }> };

export type PlaceholderProductSearch_PossibleMaterialsQueryVariables = Types.Exact<{
  filter: Types.MaterialVariantsForPlaceholderTliFilter;
  orderBy?: Types.InputMaybe<Types.MaterialVariantOrderBy>;
}>;


export type PlaceholderProductSearch_PossibleMaterialsQuery = { __typename?: 'Query', materialVariantsForPlaceholderTli: Array<{ __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }>, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, url: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } }> };

export type PlaceholderProductSearch_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string } }>, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, url: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } };

export const PlaceholderProductSearch_RequirementsMaterialFragmentDoc = gql`
    fragment PlaceholderProductSearch_RequirementsMaterial on MaterialVariant {
  id
  materialAttributeValues {
    id
    textValue
    dimension {
      id
      name
    }
  }
}
    `;
export const PlaceholderProductSearch_RequirementsItemFragmentDoc = gql`
    fragment PlaceholderProductSearch_RequirementsItem on Item {
  id
  name
  materialAttributeDimensions {
    id
    name
    values {
      id
      textValue
    }
  }
  materialBrands {
    id
    name
  }
}
    `;
export const PlaceholderProductSearch_MaterialVariantFragmentDoc = gql`
    fragment PlaceholderProductSearch_MaterialVariant on MaterialVariant {
  id
  code
  displayName
  materialAttributeValues {
    id
    textValue
    dimension {
      id
      name
    }
  }
  featuredImage {
    id
    sortOrder
    asset {
      id
      url
      previewUrl(resizing: {height: 250, region: FULL})
    }
  }
  modelNumber
  listing {
    id
    brand {
      id
      name
    }
  }
}
    `;
export const PlaceholderProductSearch_RequirementsTliDocument = gql`
    query PlaceholderProductSearch_RequirementsTli($placeholderTliId: ID!) {
  takeoffLineItem(id: $placeholderTliId) {
    id
    materialVariant {
      ...PlaceholderProductSearch_RequirementsMaterial
    }
    item {
      ...PlaceholderProductSearch_RequirementsItem
    }
  }
}
    ${PlaceholderProductSearch_RequirementsMaterialFragmentDoc}
${PlaceholderProductSearch_RequirementsItemFragmentDoc}`;

/**
 * __usePlaceholderProductSearch_RequirementsTliQuery__
 *
 * To run a query within a React component, call `usePlaceholderProductSearch_RequirementsTliQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderProductSearch_RequirementsTliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderProductSearch_RequirementsTliQuery({
 *   variables: {
 *      placeholderTliId: // value for 'placeholderTliId'
 *   },
 * });
 */
export function usePlaceholderProductSearch_RequirementsTliQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables> & ({ variables: PlaceholderProductSearch_RequirementsTliQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>(PlaceholderProductSearch_RequirementsTliDocument, options);
      }
export function usePlaceholderProductSearch_RequirementsTliLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>(PlaceholderProductSearch_RequirementsTliDocument, options);
        }
// @ts-ignore
export function usePlaceholderProductSearch_RequirementsTliSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>;
export function usePlaceholderProductSearch_RequirementsTliSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlaceholderProductSearch_RequirementsTliQuery | undefined, PlaceholderProductSearch_RequirementsTliQueryVariables>;
export function usePlaceholderProductSearch_RequirementsTliSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>(PlaceholderProductSearch_RequirementsTliDocument, options);
        }
export type PlaceholderProductSearch_RequirementsTliQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_RequirementsTliQuery>;
export type PlaceholderProductSearch_RequirementsTliLazyQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_RequirementsTliLazyQuery>;
export type PlaceholderProductSearch_RequirementsTliSuspenseQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_RequirementsTliSuspenseQuery>;
export type PlaceholderProductSearch_RequirementsTliQueryResult = ApolloReactCommon.QueryResult<PlaceholderProductSearch_RequirementsTliQuery, PlaceholderProductSearch_RequirementsTliQueryVariables>;
export const PlaceholderProductSearch_PossibleMaterialsDocument = gql`
    query PlaceholderProductSearch_PossibleMaterials($filter: MaterialVariantsForPlaceholderTliFilter!, $orderBy: MaterialVariantOrderBy) {
  materialVariantsForPlaceholderTli(filter: $filter, orderBy: $orderBy) {
    ...PlaceholderProductSearch_MaterialVariant
  }
}
    ${PlaceholderProductSearch_MaterialVariantFragmentDoc}`;

/**
 * __usePlaceholderProductSearch_PossibleMaterialsQuery__
 *
 * To run a query within a React component, call `usePlaceholderProductSearch_PossibleMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlaceholderProductSearch_PossibleMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlaceholderProductSearch_PossibleMaterialsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePlaceholderProductSearch_PossibleMaterialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables> & ({ variables: PlaceholderProductSearch_PossibleMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>(PlaceholderProductSearch_PossibleMaterialsDocument, options);
      }
export function usePlaceholderProductSearch_PossibleMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>(PlaceholderProductSearch_PossibleMaterialsDocument, options);
        }
// @ts-ignore
export function usePlaceholderProductSearch_PossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>;
export function usePlaceholderProductSearch_PossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PlaceholderProductSearch_PossibleMaterialsQuery | undefined, PlaceholderProductSearch_PossibleMaterialsQueryVariables>;
export function usePlaceholderProductSearch_PossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>(PlaceholderProductSearch_PossibleMaterialsDocument, options);
        }
export type PlaceholderProductSearch_PossibleMaterialsQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_PossibleMaterialsQuery>;
export type PlaceholderProductSearch_PossibleMaterialsLazyQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_PossibleMaterialsLazyQuery>;
export type PlaceholderProductSearch_PossibleMaterialsSuspenseQueryHookResult = ReturnType<typeof usePlaceholderProductSearch_PossibleMaterialsSuspenseQuery>;
export type PlaceholderProductSearch_PossibleMaterialsQueryResult = ApolloReactCommon.QueryResult<PlaceholderProductSearch_PossibleMaterialsQuery, PlaceholderProductSearch_PossibleMaterialsQueryVariables>;